import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { TaigaModule } from './taiga.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HighlightModule } from 'ngx-highlightjs';
import { HttpClientModule } from '@angular/common/http';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { StorageService } from '../services/storage/storage.service';

import { SideBarComponent } from './common-components/side-bar/side-bar.component';
import { CourseCardComponent } from '../pages/main/microcourse/components/course-card/course-card.component';
import { CourseDetailDrawerComponent } from '../pages/main/microcourse/components/course-detail-drawer/course-detail-drawer.component';
import { MobileDeviceWarningComponent } from './common-components/mobile-device-warning/mobile-device-warning.component';
import { NumberGroupingPipe } from './pipes/number-grouping.pipe';
import { OnlineTimeGroupingPipe } from './pipes/online-time-grouping.pipe';
import { SkillsetCardComponent } from '../pages/main/microcourse/components/skillset-card/skillset-card.component';
import { SourceToBlobPipe } from './pipes/source-to-blob.pipe';
import { IdToNamePipe } from './pipes/id-to-name.pipe';

@NgModule({
  declarations: [
    SideBarComponent,
    CourseDetailDrawerComponent,
    CourseCardComponent,
    SkillsetCardComponent,
    MobileDeviceWarningComponent,
    NumberGroupingPipe,
    OnlineTimeGroupingPipe,
    SourceToBlobPipe,
    IdToNamePipe,
  ],
  imports: [
    CommonModule,
    TaigaModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HighlightModule,
    ScrollingModule,
    NgOptimizedImage,
  ],
  exports: [
    TaigaModule,
    FormsModule,
    ReactiveFormsModule,
    SideBarComponent,
    CourseDetailDrawerComponent,
    CourseCardComponent,
    HighlightModule,
    ScrollingModule,
    MobileDeviceWarningComponent,
    NumberGroupingPipe,
    OnlineTimeGroupingPipe,
    SkillsetCardComponent,
    SourceToBlobPipe,
    IdToNamePipe,
  ],
  providers: [StorageService],
})
export class SharedModule {}
